import tw from 'tailwind-styled-components'

export const SRUserNameContainer = tw.div`
    flex
    gap-4
    py-4
`
